import { format, parseISO } from 'date-fns';
import { useState } from 'react';
import Icon from 'components/ui/Icon';
import Link from 'components/ui/Link';
import Stars from 'components/ui/Stars';
import tailwind from 'utils/breakpoints';
import { useTranslation } from 'hooks/useTranslation';
import type { ReviewItem } from 'types/Review';
import type { MouseEventHandler } from 'react';

type Props = {
  review: ReviewItem;
};

const Testimonial = ({ review }: Props): JSX.Element => {
  const { t } = useTranslation();
  const [showLongText, setShowLongText] = useState(false);
  const textLimit = 500;

  const toggle: MouseEventHandler = (e) => {
    e.preventDefault();
    setShowLongText(!showLongText);
  };

  return (
    <>
      <div
        className="text-navy font-bold uppercase mb-2"
        style={{ fontSize: '13px' }}
      >
        <div className="font-netto flex items-center mb-2">
          <Icon
            color={tailwind.theme.backgroundColor.navy}
            type="Verified"
            className="w-4 mr-1"
            style={{ fontSize: '13px' }}
          />
          {t('reviews.verified')}
        </div>
      </div>
      <p className="font-bold mb-2">
        {review.customerName}, {review.customerCountryName}
      </p>
      {review.date && (
        <p className="mb-2 md:text-sm">
          {format(parseISO(review.date as string), 'MMMM dd, yyyy')}
        </p>
      )}
      <div className="flex flex-wrap mb-3 text-xs">
        <div className="mb-3 mr-4">
          <p>{t('reviews.overall')}</p>
          <Stars rating={review.overallRating} starSize={12} />
        </div>
        <div className="mb-3 mr-4">
          <p>{t('reviews.friendliness')}</p>
          <Stars rating={review.friendliness} starSize={12} />
        </div>
        <div className="mb-3">
          <p>{t('reviews.facilities')}</p>
          <Stars rating={review.facilities} starSize={12} />
        </div>
      </div>
      <p className="font-bold md:text-sm">{review.descriptionShort}</p>
      <p className="md:text-sm" style={{ lineHeight: '26px' }}>
        {(review.description?.length || 0) < textLimit ? (
          review.description
        ) : (
          <>
            {showLongText ? (
              <>
                {review.description}
                <Link href="#">
                  <a className="font-bold text-navy ml-2" onClick={toggle}>
                    {t('reviews.showLess')}
                  </a>
                </Link>
              </>
            ) : (
              <>
                {review.description?.slice(0, textLimit)}...{' '}
                <Link href="#">
                  <a className="font-bold text-navy" onClick={toggle}>
                    {t('reviews.showMore')}
                  </a>
                </Link>
              </>
            )}
          </>
        )}
      </p>
    </>
  );
};

export default Testimonial;
